import View from './View';
import Edit from './Edit';
import ItemsSchema from './schema';
import icon from '@plone/volto/icons/list-arrows.svg';

const ItemsBlock = {
  id: 'items',
  title: 'Items',
  view: View,
  edit: Edit,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: ItemsSchema,
};

export default ItemsBlock;
